import { cva, VariantProps } from 'class-variance-authority'
import { forwardRef, type InputHTMLAttributes } from 'react'

const checkboxStyles = cva(
  [
    'appearance-none p-0 inline-block align-middle bg-origin-border select-none shrink-0 h-4 w-4 bg-white border border-gray-200 rounded-[4px] transition-all outline-none bg-no-repeat bg-center bg-[length:50%]',
    'checked:bg-[url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%209%207%22%3E%3Cpath%20fill%3D%22currentColor%22%20fill-rule%3D%22evenodd%22%20d%3D%22M.023%203.563%203.045%206.77l5.524-5.7L7.605.055l-4.546%204.69L1%202.555.023%203.563Z%22%20clip-rule%3D%22evenodd%22%20%2F%3E%3C%2Fsvg%3E)]',
  ],
  {
    variants: {
      variant: {
        primary: [
          'checked:bg-primary-400 checked:border-primary-800',
          'focus-visible:ring-2 focus-visible:ring-primary-100 ',
        ],
        dark: '',
      },
    },

    defaultVariants: {
      variant: 'primary',
    },
  },
)

type CheckboxStyling = VariantProps<typeof checkboxStyles>

interface PropTypes extends InputHTMLAttributes<HTMLInputElement>, CheckboxStyling {}

const Checkbox = forwardRef<HTMLInputElement, PropTypes>(function Checkbox ({ name, children, variant, ...rest }, ref) {
  return (
    <div className="flex gap-2 items-center text-xs leading-3 text-gray-600">
      <input
        id={name}
        ref={ref}
        name={name}
        type="checkbox"
        className={checkboxStyles({ variant })}
        {...rest}
      />
      <label
        htmlFor={name}
        className="cursor-pointer"
      >
        {children}
      </label>
    </div>
  )
})

export default Checkbox
